module.exports = __webpack_public_path__ + "img/0.9f177e26.jpg";